<template>
  <table class="table table-details">
    <tr>
      <td><label>{{ $t('generic.id') }}</label></td>
      <td>{{ details.id }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.created') }}</label></td>
      <td>{{ details.created_at | time }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.createdBy') }}</label></td>
      <td>{{ details.created_by }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.updated') }}</label></td>
      <td>{{ details.updated_at | time }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.updatedBy') }}</label></td>
      <td>{{ details.modified_by }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('emailTemplates.form.type') }}</label></td>
      <td>{{ details.type }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('emailTemplates.form.language') }}</label></td>
      <td>{{ details.language }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('emailTemplates.form.short_name') }}</label></td>
      <td>{{ details.short_name }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('emailTemplates.form.email_subject') }}</label></td>
      <td>{{ details.email_subject }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('emailTemplates.form.description') }}</label></td>
      <td>{{ details.description }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('emailTemplates.form.email_content_html') }}</label>
        <base-button size="sm" icon type="info" @click="openEmail(details.type+'-'+details.language, details.email_content_html)">
          <i class="tim-icons icon-light-3"></i>
        </base-button>
      </td>
      <td>
        {{ details.email_content_html }}
      </td>
    </tr>
    <tr>
      <td><label>{{ $t('emailTemplates.form.email_content') }}</label></td>
      <td class="note">
        <pre>{{ details.email_content }}</pre>
      </td>
    </tr>
  </table>
</template>
<script>

export default {
  name: 'emailTemplateDetails',
  components: {
  },
  data() {
    return {
    }
  },
  props: {
    details: {
      type: Object,
      required: true,
    },
  },
  methods: {
    openEmail(windowName, content) {
      let newWin = open('', windowName, 'popup=1,toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=700,height=800,top="+(screen.height-400)+",left="+(screen.width-840)');
      newWin.document.write(content);
      newWin.document.close()
    }
  }
};
</script>
<style>
.note pre {
  white-space: pre-wrap;
  word-wrap: break-word;
  font-family: inherit;
}
</style>
